import EzController from 'controllers/ez-base-controller';
import Cookies from 'js-cookie';
import EzPopunder from 'components/util/ez-popunder';
import {
  isHomepage, triggerCustomEvent, featureEnabled, getFormattedPageValue,
} from 'lib/helpers';
import { sendTrackingEvent, NEW_ANALYTICS_FEATURE } from 'components/analytics/conversions/tracking';
import { PARTNER_POPUP_TRIGGERED } from 'components/analytics/conversions/constants/actions';
import events from 'lib/events';

export default class PartnerPopupController extends EzController {
  static targets = ['currentPage']

  static values = {
    terms: String,
    page: Number,
    totalPages: Number,
    source: String,
  }

  connect() {
    this.impactRadiusUrl = this.element.getAttribute('data-impact-radius-url');
    this.impactRadiusSearchPopupUrl = this.element.getAttribute('data-impact-radius-search-popup-url');
  }

  maybePagination(event) {
    this.mode = 'pagination';

    if (!this.recentlySeenPopup()) {
      if (featureEnabled(NEW_ANALYTICS_FEATURE) && this.hasSearchValues) {
        sendTrackingEvent({
          data: {
            action: PARTNER_POPUP_TRIGGERED,
            label: `Terms-${this.termsValue}`,
            value: this.getNavigationPage(event.target),
            partner_popup_origin: this.sourceValue,
          },
        });
      }

      triggerCustomEvent(events.partner.pagination_popup, {});
      this.openPopup();
    }
  }

  getNavigationPage(target) {
    if (!target || !this.hasCurrentPageTarget) return this.pageValue;

    if (target === this.currentPageTarget) {
      const page = parseInt(getFormattedPageValue(this.currentPageTarget), 10);

      return page > this.totalPagesValue ? this.totalPagesValue : page;
    }

    return this.pageValue;
  }

  maybeSearch() {
    this.mode = 'search';

    if (!this.recentlySeenPopup() && this.isLucky() && !isHomepage()) {
      triggerCustomEvent(events.partner.search_popup, {
        subId1: this.subId1(),
        subId2: this.subId2(),
      });

      this.openPopup();
    }
  }

  openPopup() {
    Cookies.set('sstkSearchPU', { lastSeen: Date.now() });

    // TODO: implement skip-sstk-popup, or is that a failed split test?
    const popup = new EzPopunder();

    popup.open(this.partnerUrl());
  }

  recentlySeenPopup() {
    const cookie = Cookies.getJSON('sstkSearchPU');

    if (!cookie) return false;

    const thirtyMinutes = 1000 * 60 * 30;
    const threshold = Date.now() - thirtyMinutes;

    return cookie.lastSeen > threshold;
  }

  isLucky() {
    // 3. The lucky number is 3.
    return this.randomNumber() === 3;
  }

  randomNumber() {
    // return a random number between 1 and 5, inclusively
    return Math.floor(Math.random() * 5) + 1;
  }

  get searchTerm() {
    const searchForm = document.querySelector("[data-controller~='search-form']");

    if (!searchForm) {
      return null;
    }

    if (this.mode === 'pagination') {
      return searchForm.getAttribute('data-search-term').replace(/-/g, ' ');
    }

    const searchInput = searchForm.querySelector('input[name=search]');
    if (searchInput) {
      return searchInput.value;
    }

    return null;
  }

  partnerUrl() {
    switch (this.mode) {
      case 'search':
        return this.makePopupUrl(encodeURIComponent(this.subId1()));
      case 'pagination':
        return this.makePopupUrl('pagination');
      default:
        return null;
    }
  }

  makePopupUrl(subId1) {
    const params = {
      u: encodeURIComponent(this.destinationUrl),
      sharedid: window.location.hostname,
      subId1,
      subId2: this.subId2(),
      subId3: this.subId3(),
      adtype: this.adType,
      adplacement: 'POP',
    };

    let impactUrl = '';
    switch (this.mode) {
      case 'search':
        impactUrl = this.impactRadiusSearchPopupUrl;
        break;
      case 'pagination':
        impactUrl = this.impactRadiusUrl;
        break;
      default:
        impactUrl = this.impactRadiusUrl;
    }

    return `${impactUrl}?${
      Object.keys(params).map((key) => `${key}=${params[key]}`).join('&')}`;
  }

  subId1() {
    if (this.mode === 'pagination') {
      return 'pagination';
    }

    const { classList } = document.body;

    if (classList.contains('home-home_vectors')) {
      return 'SearchPopHome';
    }

    if (classList.contains('resources-show')) {
      return 'SearchPopShow';
    }

    if (classList.contains('searches-show')) {
      return 'SearchPopSearch';
    }

    return 'SearchPopOther';
  }

  subId2() {
    return document.body.getAttribute('data-pageview-guid');
  }

  subId3() {
    return `${this.searchTerm}_null_${this.mode}pop`;
  }

  get hasSearchValues() {
    return this.hasTermsValue && this.hasPageValue && this.hasSourceValue;
  }

  get destinationUrl() {
    return this.element.getAttribute('data-destination-url').replace(/{{search_term}}/g, this.searchTerm);
  }

  get adType() {
    return Cookies.get('content_type') || 'vector';
  }

  isMobile() {
    return document.body.classList.contains('is-mobile');
  }
}
